import React from "react";

export function parsePurpose({ for_gam_api, for_console_proxy }) {
  const result = [];

  if (for_console_proxy && for_console_proxy === 1) {
    result.push(
      <span className="border rounded-2xl border-gray-500 bg-gray-100 px-4 font-semibold text-gray-700">
        Console Proxy
      </span>
    );
  }

  if (for_gam_api && for_gam_api === 1) {
    result.push(
      <span className="border rounded-2xl border-gray-500 bg-gray-100 px-4 font-semibold text-gray-700">
        GAM API
      </span>
    );
  }

  return (
    <div className="flex flex-wrap gap-2 text-xs">
      {result.map((item, index) => (
        <React.Fragment key={index}>{item}</React.Fragment>
      ))}
      {result.length === 0 && "--"}
    </div>
  );
}
